import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../components/Login';
import Overview from '../components/Overview';
import Inputdata from '../components/Inputdata';
import Inputcompany from '../components/Inputcompany';
import User from '../components/User';
import CRM from '../components/CRM';
import Requests from '../components/Requests';
import UploadAds from '../components/UploadAds';
import Company from '../components/Company';
import View from '../components/View';
import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueSession from 'vue-session';
import {
  library
} from '@fortawesome/fontawesome-svg-core';
import {
  faUserSecret,
  faUserAlt,
  faLaptop,
  faSearch,
  faPlus,
  faAddressBook,
  faSave,
  faRedoAlt,
  faTimes,
  faCheck,
  faEdit,
  faTrash,
  faUserEdit,
  faUserPlus,
  faEye,
  faCog,
  faTools,
  faCheckSquare,
  faUpload
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faLine
} from '@fortawesome/fontawesome-free-brands';
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome';
library.add(faUserSecret, faUserAlt, faLaptop, faFacebookF, faLine, faSearch,faPlus, faUpload, faAddressBook, faSave, faRedoAlt, faTimes, faCheck, faEdit, faTrash, faUserEdit, faUserPlus, faEye, faCog, faTools, faCheckSquare);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueSession);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/Overview',
    name: 'Overview',
    component: Overview
  },
  {
    path: '/Inputdata',
    name: 'Inputdata',
    component: Inputdata
  },
  {
    path: '/Inputcompany',
    name: 'Inputcompany',
    component: Inputcompany
  },
  {
    path: '/Company',
    name: 'Company',
    component: Company
  },
  {
    path: '/User',
    name: 'User',
    component: User
  },
  {
    path: '/Requests',
    name: 'Requests',
    component: Requests
  },
  {
    path: '/UploadAds',
    name: 'UploadAds',
    component: UploadAds
  },
  {
    path: '/CRM',
    name: 'CRM',
    component: CRM
  },
  {
    path: '/View',
    name: 'View',
    component: View
  }
  
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;